import { render } from "./Gallery.vue?vue&type=template&id=4972b448&scoped=true"
const script = {}

import "./Gallery.vue?vue&type=style&index=0&id=4972b448&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Zayd\\Documents\\Web Development\\Clients Projects\\RHDesigns\\rhdesigns-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4972b448"]])

export default __exports__